export const SearchIcon = ({ className = '' }) => {
  return (
    <svg
      className={className}
      width="9"
      height="9"
      viewBox="0 0 9 9"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Group 2086">
        <circle id="Ellipse 74" cx="3.5" cy="3.5" r="3" stroke="#303030" />
        <rect
          id="Rectangle 3015"
          x="4.89648"
          y="5.604"
          width="1"
          height="4.50781"
          transform="rotate(-45 4.89648 5.604)"
          fill="#303030"
        />
      </g>
    </svg>
  )
}
